module.exports = __webpack_public_path__ + "img/sphere09-graph-black.0c460c02.png";